  export const lineKeyMap = {
    totalScore: {
      color: "#816cbc",
    },
    action_setting_score: {
      color: "#962EFF",
    },
    building_the_relationship_score: {
      color: "#D1C7FF",
    },
    deepening_thinking_score: {
      color: "#00B2D6",
    },
    reviewing_actions_score: {
      color: "#00c7d2",
    },
    eq_score: {
      color: "#962EFF",
    },
    impact_score: {
      color: "#D1C7FF",
    },
    super_influencer_score: {
      color: "#00B2D6",
    },
  };